<script lang="ts">
  import { onMount } from 'svelte';
  import { getAppContext } from '../context.js';
  import { saveAllActiveSessions } from '../../session/session-registry.js';

  const { platform, matchPersistence, writeQueue } = getAppContext();

  onMount(() => {
    const unregisterFlush = platform.lifecycle.registerFlushHandler(async () => {
      await saveAllActiveSessions();
      await matchPersistence.flush();
      await writeQueue.flush();
    });

    const unregisterVisibility = platform.lifecycle.onVisibilityChange((visibility) => {
      if (visibility === 'hidden') {
        void platform.lifecycle.flushPendingWork();
      }
    });

    return () => {
      unregisterFlush();
      unregisterVisibility();
    };
  });
</script>
